import { render, staticRenderFns } from "./TaskHeader.vue?vue&type=template&id=71cda759&scoped=true&"
import script from "./TaskHeader.vue?vue&type=script&lang=js&"
export * from "./TaskHeader.vue?vue&type=script&lang=js&"
import style0 from "./TaskHeader.vue?vue&type=style&index=0&id=71cda759&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cda759",
  null
  
)

export default component.exports